var exports = {
  "U": "x31de4314--a8d68b--buttons",
};

module.exports = exports;
